"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeBitmap = void 0;
var Bitmap_1 = require("../Bitmap");
/**
 * Creates a {@link Bitmap} for the canvas, containing all pixels.
 */
function makeBitmap(ctx) {
    var imageData = ctx.getImageData(0, 0, ctx.getCanvasWidth(), ctx.getCanvasHeight());
    return new Bitmap_1.Bitmap(imageData.width, imageData.height, imageData.data);
}
exports.makeBitmap = makeBitmap;
//# sourceMappingURL=makeBitmap.js.map